export default __webpack_public_path__ + "static/media/this_is_your_comunity.213c2fe9.webp";